import { render, staticRenderFns } from "./mess.vue?vue&type=template&id=68b9a86a&scoped=true"
import script from "./mess.vue?vue&type=script&lang=js"
export * from "./mess.vue?vue&type=script&lang=js"
import style0 from "./mess.vue?vue&type=style&index=0&id=68b9a86a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b9a86a",
  null
  
)

export default component.exports